import { computed, Injectable, signal } from '@angular/core';
import { compareHtmlText } from 'shared/util-common';

import { GuidelineComponent, GuidelineComponentLocalChanges } from '@treetop/shared/model';

export type MergeConflictStatus = 'resolved' | 'conflict' | undefined;

@Injectable()
export class MergeConflictService {
  private element = signal<GuidelineComponent | undefined>(undefined);

  private mergeConflictStatus = computed<MergeConflictStatus>(() => {
    const descriptionStatus = this.originalMergeConflicts().description
      ? this.isDescriptionMergeConflictResolved()
        ? 'resolved'
        : 'conflict'
      : undefined;

    const statuses = [descriptionStatus];
    const hasOriginalMergeConflict = this.originalMergeConflicts().description;

    return statuses.every((stat) => stat === 'resolved')
      ? 'resolved'
      : statuses.some((stat) => stat === 'conflict')
        ? 'conflict'
        : hasOriginalMergeConflict
          ? 'resolved'
          : undefined;
  });

  private isDescriptionMergeConflictResolved = signal(false);

  private descriptionMergeConflictStatus = computed<MergeConflictStatus>(() => {
    return !this.originalMergeConflicts().description ? undefined : this.isDescriptionMergeConflictResolved() ? 'resolved' : 'conflict';
  });

  public mergeConflictViewModel = computed(() => {
    return {
      mergeConflictStatus: this.mergeConflictStatus(),
      descriptionMergeConflictStatus: this.descriptionMergeConflictStatus(),
    };
  });

  private originalMergeConflicts = signal({
    description: false,
  });

  private originalLocalChanges: GuidelineComponentLocalChanges;

  public init(element: GuidelineComponent): void {
    this.element.set(element);

    // TODO: adapt to component widgets
    // this.originalLocalChanges = this.element()?.localChanges;
    //
    // const hasOriginalDescriptionMergeConflict = this.hasTextMergeConflict(element.localChanges?.description, element.description);
    //
    // this.originalMergeConflicts.set({
    //   description: hasOriginalDescriptionMergeConflict,
    // });
  }

  public getOriginalLocalChanges() {
    return {
      description: this.originalLocalChanges.description,
    };
  }

  public resolveDescriptionMergeConflict(): void {
    this.isDescriptionMergeConflictResolved.set(true);
  }

  public resolveMergeConflict(): void {
    this.isDescriptionMergeConflictResolved.set(true);
  }

  public unresolveMergeConflict(): void {
    this.isDescriptionMergeConflictResolved.set(false);
  }

  private hasTextMergeConflict(current: string | undefined, original: string): boolean {
    return !!(current && !compareHtmlText(original, current ?? ''));
  }
}
